<template>
    <div class="answerSheet">
        <div class="wraper">
            <div class="wraper_hz">
                <div style="display: flex;justify-content: space-between;">
                <div class="wraper_dtk">答题卡<span>（<span style="color: rgb(40, 107, 255);">{{answerData.curQuestionNum + 1}}</span>/{{questionList.length }}）</span></div>
                <div v-if="query.type !== 'check'" class="wraper_zongf">总分：{{answerData.Scoretm}}</div>
                </div>
                <div v-if="query.type !== 'check'" class="wraper_jzsj">截至时间：{{query.end_time}}</div>
                <div v-else class="wraper_jzsj">完成时间：{{query.end_time}}</div>
            </div>
            <div class="wraper_dttshz">
                <div class="wraper_datixs">
                <div class="wraper_yddqwdjdzq"></div>
                <span>正确</span>
                </div>
                <div class="wraper_datixs">
                <div class="wraper_yddqwdjd wraper_yddqwdjdyicw"></div>
                <span>错误</span>
                </div>
                <div v-if="isShowAnswered" class="wraper_datixs">
                <div class="wraper_yddqwdjd wraper_yddqwdjdyicw1"></div>
                <span>已答</span>
                </div>
            </div>
            <div style="margin-top: 8px;" class="wraper_dttshz">
                <div class="wraper_datixs">
                <div class="wraper_yddqwdjd wraper_yddqwdjdyi"></div>
                <span>当前</span>
                </div>
                <div class="wraper_datixs">
                <div class="wraper_yddqwdjd wraper_yddqwdjder"></div>
                <span>未答</span>
                </div>
                <div class="wraper_datixs">
                <img style="margin-left: 16px;margin-right: 2.8px;" src="../images/weida_jdt.png" alt="">
                <span>简答题</span>
                </div>
            </div>
            <div :class="query.type !== 'check'?'wraper_dtktm':'wraper_dtktmyi'">
                <div
                    v-for="(item, index) in questionList"
                    :key="item.id"
                    @click="handleClick(item, index)"
                >
                    <div>
                            <div class="answerSheetContent-item-dot" :class="[calculateMultiplesOfSix(index + 1) ? 'lastItem':'', questionClass(item, index)]">
                            <span>{{index + 1}}</span>
                            <template v-if="item.type == 4">
                                <img src="../images/jiandat_ys.png" alt="">
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        answerData: {
            type: Object,
            default: () => {}
        },
        questionList: {
            type: Array,
            default: () => []
        },
        curQuestionNum: {
            type: Number,
            default: 0
        },
        modeType: { // 1为考试模式 2为逐题模式
            type: [String, Number],
            default: ''
        },
        isShowCurrent: { // 是否显示当前题目
            type: Boolean,
            default: true
        },
        isShowAnswered: { // 是否显示已答题目
            type: Boolean,
            default: true
        },
    },
    computed: {
        query() {
            return this.answerData.query || {}
        },
        questionClass() {
            return (item, index) => {
                let classArr = []
                // item.user_answer ? (modeType == 1 ? 'answered' : this.grtSortData(item.user_answer) == this.grtSortData(item.answer) ? 'success' : 'fail') : 'unanswered',
                // item.type === 4 ? 'shortQuestion' : '',
                // (curQuestionNum == index) && isShowCurrent ? 'currentAnswer' : '',

                // 判断用户答案的状态
                console.log(item, 'item')
                if (item.user_answer) {
                    if (this.modeType === 1) {
                        classArr.push('answered')
                    } else {
                        if (item.isShowAnswered) {
                            classArr.push('answered')
                        } else {
                            const isSuccess = this.grtSortData(item.user_answer) === this.grtSortData(item.answer)
                            classArr.push(isSuccess ? 'success' : 'fail')
                        }
                    }
                } else {
                    classArr.push('unanswered')
                }
                // 判断题目类型
                if (item.type === 4) {
                    classArr.push('shortQuestion')
                }

                // 判断是不是当前显示状态
                if (this.curQuestionNum === index && this.isShowCurrent) {
                    classArr.push('currentAnswer')
                }

                return classArr

            }
        }
    },
    methods: {
        handleClick(item, index) {
            this.$emit('handleClick', item, index)
        },
        grtSortData(data) {
            console.log(data,'12312312321')
            if (data && data.length) {
                return data.split('').sort().join('')
            }
            return ''
        },
        calculateMultiplesOfSix(item) {
            // 循环从1到118，检查每个数字是否是6的倍数，并添加到数组中
            if (item % 6 === 0) {
                return true
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.answerSheet {
    width: 100%;
}
.wraper {
  width: 300px;
  height: 753px;
  background: #ffffff;
  margin-top: 20px;
  float: left;
  .wraper_ydwckfhz {
    width: 276px;
    height: 268px;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 20px;
    position: relative;
    .wraper_gkxx {
      width: 252px;
      height: 0px;
      border: 1px dashed rgba(40,107,255,0.40);
      margin: 0 auto;
      margin-top: 16px;
    }
    .wraper_lgfshz {
      display: flex;
      justify-content: space-between;
      margin-left: 12px;
      margin-top: 24px;
      .wraper_bsfzd {
        font-size: 40px;
        font-family: DINPro, DINPro-700;
        font-weight: 700;
        color: #286bff;
        margin-right: 12px;
        .wraper_bsneidf {
          font-size: 14px;
          color: #848586;
          font-weight: 400;
          margin-left: 4px;}
      }
      .wraper_zongfenib {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #848586;
        margin-top: 4px;
      }
      .wraper_bczypf {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-600;
        font-weight: 600;
        color: #202020;
      }
    }
  }
  .wraper_zwbxt {
    width: 300px;
    height: 109px;
    position: absolute;
    background: url(../images/chakandwtmt.png);
    background-size: 100% 100%;
    top: 20px;
  }
  .wraper_dtktmyi {
    display: flex;
    flex-wrap: wrap;
    width: 252px;
    max-height: 375px;
    overflow-y: auto;
    margin: 0 auto;
    .wraper_dtktmcz{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 0px;
      cursor: pointer;
    }
    .wraper_dtktmczer{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .wraper_dtktm {
    display: flex;
    flex-wrap: wrap;
    width: 252px;
    max-height: 647px;
    overflow-y: auto;
    margin: 0 auto;
    .wraper_dtktmcz{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 0px;
      cursor: pointer;
    }
    .wraper_dtktmczer{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .wraper_dttshz {
    width: 252px;
    height: 20px;
    display: flex;
    margin: 0 auto;
    margin-top: 16px ;
    .wraper_datixs {
      display: flex;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      img {
        width: 16px;
        height: 16px;
        border-radius: 18px;
      }
      .wraper_yddqwdjdzq {
        width: 14px;
        height: 14px;
        background: #10b881;
        border: 0.8px solid #10b881;
        border-radius: 80px;
        margin-right: 2.8px;
        margin-top: 2px;
      }
      .wraper_yddqwdjd {
        width: 14px;
        height: 14px;
        background: #286bff;
        border: 0.8px solid #286bff;
        border-radius: 80px;
        margin-right: 2.8px;
        margin-top: 2px;
      }
      .wraper_yddqwdjdyicw {
        background: #ff8982;
        border: 0.8px solid #ff8982;
        margin-left: 16px;
      }
      .wraper_yddqwdjdyicw1 {
        background: #286BFF ;
        border: 0.8px solid #286BFF ;
        margin-left: 16px;
      }
      .wraper_yddqwdjdyi {
        background: #d4e1ff;
        border: 0.8px solid #d4e1ff;
      }
      .wraper_yddqwdjder {
        background: #fff;
        border: 0.8px solid #e3e8e9;
        margin-left: 16px;
      }
    }
  }
  .wraper_hz {
    width: 252px;
    height: 46px;
    margin: 0 auto;
    margin-top: 20px;
    .wraper_jzsj {
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      margin-top: 5.5px;
    }
    .wraper_zongf {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      color: #848586;
    }
    .wraper_dtk {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      color: #202020;
      span {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-500;
        font-weight: 500;
        color: #848586;
      }
    }
  }
}

.answerSheetContent-item-dot {
    width: 30px;
    height: 30px;
    border: 1px solid #e3e8e9;
    border-radius: 20px;
    margin-top: 16px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    text-align: center;
    color: #202020;
    line-height: 30px;
    margin-right: 10px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    &.lastItem {
        margin-right: 0px;
    }
    img {
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
        height: 10px;
        border-radius: 0 0 50% 50%;
    }
}

.success {
    background: #10B881 !important;
    border: 1px solid #10B881 !important;
    color: #ffffff !important;
}
.fail {
    background: #FF8982 !important;
    border: 1px solid #FF8982 !important;
    color: #ffffff !important;
}
.shortQuestion {
    background: #E3E8E9 !important;
    border: 1px solid #E3E8E9 !important;
    color: #202020 !important;
}
.answered {
    background: #286BFF !important;
    border: 1px solid #286BFF !important;
    color: #ffffff !important;
}
.currentAnswer {
    background: #D4E1FF !important;
    border: 1px solid #D4E1FF !important;
    color: #286BFF !important;
}
</style>